import { configureStore } from '@reduxjs/toolkit'
import authReducer from '../features/auth/authSlice'
import decksReducer from '../features/decks/decksSlice'
import flooringReducer from '../features/flooring/flooringSlice'
import drywallReducer from '../features/drywall/drywallSlice'
import basementsReducer from '../features/basements/basementsSlice'
import homeReducer from '../features/home/homeSlice'
import contactReducer from '../features/contact/contactSlice'

export const store = configureStore({
	reducer: {
		auth: authReducer,
		decks: decksReducer,
		flooring: flooringReducer,
		drywall: drywallReducer,
		basements: basementsReducer,
		homeImages: homeReducer,
		contact: contactReducer,
	},
})
